import type { FunctionComponent } from "react"

import { InfoCircleOutlined } from "@jobteaser/spark/components/Icons/InfoCircleOutlined"
import { Text } from "@jobteaser/spark/components/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"

import styles from "./StatusUserNotAvailable.module.css"

export const StatusUserNotAvailable: FunctionComponent = () => {
  const { t, tReact } = useTranslation(["event_details"])
  const locale = useLocale()

  const myEventsLink = (
    <Link href={`/${locale}/dashboard/my_events`}>{t("event_details.registration.not.available.link")}</Link>
  )

  return (
    <div className={styles.main} data-testid="event-details-registration-details-user-status-not-available">
      <InfoCircleOutlined className={styles.icon} size={24} />
      <Text
        variant="body1"
        className={styles.text}
        data-testid="event-details-registration-details-user-status-not-available-text"
      >
        {tReact("event_details.registration.not.available", {
          my_events_link: myEventsLink,
        })}
      </Text>
    </div>
  )
}
